import { ITimelineData } from './../../shared/interactivity-editor/redux/timeline-data.model';
import { DialogDefinition } from './../../../services/overlay.service';
import { TranslateService } from '@ngx-translate/core';
import { InteractivityEditorService } from './../../shared/interactivity-editor/services/interactivity-editor.service';
import { ModalDefinition } from '../../../services/overlay.service';
import { LocationService } from './../../../services/location.service';
import { AssetService } from './../../../services/asset.service';
import { SapiService, SapiEntityVersion, SapiEntity } from './../../../services/sapi.service';
import { Component, ViewChild, TemplateRef, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

import { AbstractDetailsComponent } from '../../shared/abstract-details.component';
import { NgForm } from '@angular/forms';
import { UNDOABLE_TYPE } from '../../../shared/redux/enums/undoable.type.enum';
import { REDUX_STORE_TIMELINE_DATA } from '../../../shared/redux/app.store'; // NB!
import { PublicationService } from '../../../services/publication.service';
import { TimelineDataActions } from '../../shared/interactivity-editor/redux/timeline-data-actions';
import { Mediaclip } from '../../../interfaces/mediaclip';
import { IWidget } from '../../../components/shared/interactivity-editor/interfaces/IWidget';
import { WidgetType } from '../../../components/shared/interactivity-editor/enums/WidgetType';
import { Observable } from 'rxjs';

@Component({
	selector: 'interactivity-timeline-details',
	templateUrl: './interactivity-timeline-details.component.html',
	styleUrls: ['./interactivity-timeline-details.component.scss']
})

export class InteractivityTimelineDetailsComponent extends AbstractDetailsComponent implements OnInit, OnDestroy {
	@ViewChild('formRef', { static: true }) form: NgForm;
	@ViewChild('publishDraftItemsTemplate') publishDraftItemsTemplate: TemplateRef<any>;

	showVersions: boolean;
	customFonts: any[];

	toPublishMediaClips: any[];
	assetBaseUrl: string;
	ovpPreviewWindow: Window;
	private modal: ModalDefinition;

	// override
	constructor(
		public sapiService: SapiService,
		public publicationService: PublicationService,
		protected route: ActivatedRoute,
		protected location: Location,
		private assetService: AssetService,
		public interactivityEditorService: InteractivityEditorService,
		public locationService: LocationService,
		private translateService: TranslateService) {
		super(route, location);

		// start redux store for TimeLine
		this.entityConfiguration = {
			name: 'timeline',
			basePath: '/library/interactivity/',
			parentPath: '/interactivity/mediaclips', // TODO MAKE DYNAMIC FOR APPS ETC..
			backOnNewCancel: true,
			defaultVersionState: 'working',
			showVersionMetadata: true,
			useAutoSave: true,
			reduxConfig: {
				store: REDUX_STORE_TIMELINE_DATA,
				undoableType: UNDOABLE_TYPE.TIMELINE_DATA,
				loadedAction: TimelineDataActions.LOADED,
				newAction: TimelineDataActions.NEW
			},
			versioned: true,
			versionMetadataToSave: {
				bbcomment: ''
			}
		};

		this.assetBaseUrl = this.assetService.getAssetBaseUrl();
		this.customFonts = new Array<any>();
		this.loadCustomFonts();
	}

	// override
	ngOnInit() {
		super.ngOnInit();
	}

	// override
	ngOnDestroy() {
		super.ngOnDestroy();
	}


	// override
	load(id: string, duplicating: boolean = false, version?: SapiEntityVersion): Observable<SapiEntity> {
		const ret = super.load(id, duplicating, version);
		ret.subscribe(() => {
			this.interactivityEditorService.justConverted = false;
		});
		return ret;
	}

	onPublishClick() {
		const timeline = this.entity as ITimelineData;
		const form = timeline?.forms?.[0];

		if (this.interactivityEditorService.haveFormWidgets() && form) {
			if (!this.interactivityEditorService.haveFormSubmitAction()) {
				const dialog: DialogDefinition = {
					icon: 'warning',
					title: this.translate.instant('NO_FORM_SUBMIT_ACTION'),
					contents: this.translate.instant('NO_FORM_SUBMIT_ACTION_WARNING'),
					onConfirm: () => {
						this.checkForDraftAssets();
					}
				};

				return this.overlayService.createDialog(dialog);
			} else if (!(form.action || form.alsoPostToServer === 'true' || form.email)) {
				const dialog: DialogDefinition = {
					icon: 'warning',
					title: this.translate.instant('NO_FORM_ACTION'),
					contents: this.translate.instant('NO_FORM_ACTION_WARNING'),
					onConfirm: () => {
						this.checkForDraftAssets();
					}
				};

				return this.overlayService.createDialog(dialog);
			}
		}
		this.checkForDraftAssets();
	}

	// override
	publish() {
		this.interactivityEditorService.justConverted = false;
		this.closeModal();
		super.publish();
	}

	cancelPublish(): void {
		this.closeModal();
	}

	continuePublish(): void {
		this.closeModal();
		super.publish();
	}

	closeModal(): void {
		if (this.modal) {
			this.overlayService.removeModal(this.modal);
		}
	}

	checkForDraftAssets() {
		const widgets: IWidget[] = this.interactivityEditorService.widgets;
		let clipIds: string[] = new Array<string>();

		for (let i = 0, l: number = widgets.length; i < l; i++) {
			const widget: IWidget = widgets[i];
			switch (widget.type) {

				case WidgetType.Video:
					clipIds = clipIds.concat(widget.getAllConfigValues('clipid'));
					break;
				case WidgetType.Image:
					clipIds = clipIds.concat(widget.getAllConfigValues('imageid'));
					clipIds = clipIds.concat(widget.getAllConfigValues('imageid_mouseover'));
					clipIds = clipIds.concat(widget.getAllConfigValues('imageid_mousedown'));
					clipIds = clipIds.concat(widget.getAllConfigValues('imageid_toggle'));
					break;
				default:
					break;
			}
		}

		clipIds = clipIds.filter(id => id !== ''); // cleanup

		if (clipIds && clipIds.length > 0) {
			this.sapiService.getMulti('commonclip', clipIds).subscribe((clips: Mediaclip[]) => {
				this.toPublishMediaClips = null; // reset
				const draftClips: Mediaclip[] = clips.filter(clip => clip.status === 'draft');
				if (draftClips.length > 0) {

					this.toPublishMediaClips = draftClips;
					if (this.toPublishMediaClips && this.toPublishMediaClips.length > 0) {
						this.modal = {
							icon: 'exclamation-triangle',
							title: this.translateService.instant('MODAL_TITLE_WARNING DRAFT_MEDIACLIPS'),
							component: {
								name: 'custom-content',
								templateRef: this.publishDraftItemsTemplate
							}
						};

						this.overlayService.createModal(this.modal);
					}
				} else {
					// publish now
					super.publish();
				}
			}, err => {
				// sapi error when 1 of the clip is not found / not critical at this point in code, just publish timeline
				super.publish();
			});
		} else {
			// no mediaclips found in widgetspublish now
			super.publish();
		}
	}

	onPreview() {
		this.autoSave();
	}

	private loadCustomFonts(): void {
		this.sapiService
			.query('creative', [{ name: 'q', values: ['mediatype: font'] }, { name: 'sort', values: ['originalfilenameSort asc'] }], 0, 999)
			.subscribe(response => {
				if (response && response.items && response.items.length > 0) { // fonts
					for (let i = 0, l = response.items.length; i < l; i++) {
						const customFont = response.items[i];
						customFont.originalfilename = customFont.originalfilename.slice(0, customFont.originalfilename.lastIndexOf('.'));
						this.customFonts.push(customFont);
					}
				}
			});
	}
}
